import axios from 'axios';
import { getBackendBaseUrl, getDefaultBackend, getUploadTimeoutMs } from './ApiConfig';
import { getDeviceHeaders } from '../utils/helpers/sessionStore';
import { getApiService } from './ApiServices';

const TempEdgeApi = {
  post: async ({ url, payload = {}, backendType }) => {
    const apiInstance = getApiService(backendType || getDefaultBackend());
    const { data } = await apiInstance.post(url, payload);
    return { data };
  },

  // Routed through the configured instance so it inherits the auth-token request
  // interceptor and the 401 -> logout response interceptor. The interceptor keeps
  // array bodies intact (no orgId injection on arrays).
  postArray: async ({ url, payload = [], backendType }) => {
    const apiInstance = getApiService(backendType || getDefaultBackend());
    const { data } = await apiInstance.post(url, [...payload]);
    return { data };
  },

  // Same as postArray: auth token and 401 handling come from getApiService interceptors.
  postMultipart: async ({ url, payload, backendType, timeoutMs }) => {
    const apiInstance = getApiService(backendType || getDefaultBackend());
    const uploadTimeout = timeoutMs || getUploadTimeoutMs();

    const config = { timeout: uploadTimeout };
    if (!(payload instanceof FormData)) {
      config.headers = { 'Content-Type': 'multipart/form-data' };
    }

    const { data } = await apiInstance.post(url, payload, config);
    return { data };
  },

  postHeaders: async ({ url, payload, backendType }) => {
    const apiInstance = getApiService(backendType || getDefaultBackend());
    const { data } = await apiInstance.post(url, payload);
    return { data };
  },

  publicPost: async ({ url, payload, backendType }) => {
    const baseUrl = getBackendBaseUrl(backendType || getDefaultBackend());
    const { data } = await axios.post(baseUrl + url, payload, { headers: getDeviceHeaders() });
    return { data };
  },

  get: async ({ url, backendType }) => {
    const apiInstance = getApiService(backendType || getDefaultBackend());
    const { data } = await apiInstance.get(url);
    return { data };
  }
};

export default TempEdgeApi;
